import {
  getContestMaintenances,
  respondContestMaintenance,
  getContestMaintenanceById,
} from "@/common/services/contest-maintenance.api";
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { useToastContext } from "../../../../common/components/ui/toast/toast.context";
import { useCompanyStore } from "@/common/states/store/Company";

export const useGetContestMaintenance = ({ page, filters }) => {
  const companyStore = useCompanyStore();

  return useQuery({
    queryKey: ["contest-maintenances", page, filters, companyStore],
    queryFn: async () => await getContestMaintenances({ ...filters, page }),
  });
};

export const useRespondContestMaintenance = () => {
  const { notifySuccess, notifyError } = useToastContext();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      contestId,
      resolution,
      status,
    }: {
      contestId: string;
      resolution: string;
      status: string;
    }) => await respondContestMaintenance(contestId, { resolution, status }),
    onSuccess: () => {
      notifySuccess("Resposta enviada com sucesso!");
      queryClient.invalidateQueries({ queryKey: ["contest-maintenances"] });
    },
    onError: (error) => {
      notifyError(`Ocorreu um erro: ${error.message} `);
    },
  });
};

export const useContestMaintenance = (id: string) => {
  return useQuery({
    queryKey: ["contest-maintenances", id],
    queryFn: async () => await getContestMaintenanceById(id),
  });
};
